import apiFetch from '../apiFetch'

export default function (documentId, sheetId, token) {
  return apiFetch({ endPoint: `document/${documentId}/sheet/${sheetId}/download`, method: 'GET', body: null, token: token, parseBlobAndAssign: true })
}
